import type { TextWithAnchors } from "~/core";

export const isTextWithAnchors = (item: unknown): item is TextWithAnchors => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "text_with_anchors"
  );
};
